import React, { FC } from 'react';
import './static-input.css';

interface Props {
  value: string;
  formatValue?: boolean;
}

export const StaticInput: FC<Props> = ({ value }) => (
  <label>
    <input
      className="static-input"
      value={`RUB ${value}`}
      readOnly
    />
  </label>
);
